import * as React from 'react';
import { connect } from 'react-redux';
import * as Metadata from '../../../entities/Metadata';
import { EntityType } from '../../../entities/common';
import { ApplicationState } from '../../../store';
import { TenantState } from '../../../store/Tenant';
import { UserState } from '../../../store/User';
import { Resource } from '../../../store/ResourcesListStore';
import { formatFieldValue } from '../../utils/common';
import { tryGetTimephasedValueFromResource } from '../../../services/TimephasedValueService';
import { getDefaultCostRateTable } from '../../../store/selectors/costRateTableSelectors';
import { resolveTimephasedFieldFromStore } from '../../../services/TimephasedConfigService';

type OwnProps = {
    value?: number;
    item?: Resource;
    field: Metadata.Field;
    entityType?: EntityType;
};

type StateProps = {
    defaultCostRateTableId?: string;
    user: UserState;
    tenant: TenantState;
    format?: Metadata.FormatType;
};

type Props = OwnProps & StateProps;

const TimephasedValueFormatter: React.FunctionComponent<Props> = (props) => {
    const now = React.useMemo(() => new Date(), []);
    const resolvedValue = props.value 
        ?? (props.item 
            ? tryGetTimephasedValueFromResource(props.field.name, props.item, now, props.defaultCostRateTableId) : undefined);

    return (
        <span>
            {formatFieldValue(resolvedValue, props.format, props.user, props.entityType, props.tenant, props.field.name)}
        </span>
    );
};

function mapStateToProps(state: ApplicationState, ownProps: OwnProps): Omit<Props, keyof OwnProps> {
    const resolvedField = resolveTimephasedFieldFromStore(state.fields, ownProps.field) ?? ownProps.field;
    return {
        defaultCostRateTableId: getDefaultCostRateTable(state)?.id,
        user: state.user,
        tenant: state.tenant,
        format: resolvedField.settings?.format
    };
}

export default connect(mapStateToProps)(TimephasedValueFormatter);
